import { BaseComponent } from './../base/base.component';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-organization-management-quick-actions',
  template: require('./organization-management-quick-actions.component.html')
})
export class OrganizationManagementQuickActionsComponent extends BaseComponent implements OnInit {
  
  @Input() organizationId: number = -1;
  @Input() isDemo: number = 0;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-management-quick-actions/organization-management-quick-actions.component.ts